import styled from 'styled-components'

export const SectionContainer = styled.div`
    width: 80%;
    margin: 3em 0;
`

export const TextBlock = styled.p`
    margin: 1em;
`
